"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var ArrowLeft = function ArrowLeft(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    d: "M18.253 12.632H7.262l3.621 3.616a.625.625 0 11-.885.884l-4.695-4.689a.624.624 0 010-.884L9.998 6.87a.626.626 0 11.885.884l-3.632 3.628h11.002a.625.625 0 110 1.25z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(ArrowLeft);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(ArrowLeft, "ArrowLeft", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ArrowLeft.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/ArrowLeft.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9BcnJvd0xlZnQudHN4Il0sIm5hbWVzIjpbIkFycm93TGVmdCIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxTQUF5RSxHQUFHLFNBQTVFQSxTQUE0RSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUNoRjtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxDQUFDLEVBQUMsb0tBREo7QUFFRSxJQUFBLElBQUksRUFBQztBQUZQLElBREYsQ0FEZ0Y7QUFBQSxDQUFsRjs7ZUFTZSx1QkFBV0YsU0FBWCxDOzs7Ozs7Ozs7Ozs7OzBCQVRUQSxTIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGZvcndhcmRSZWYsIFJlZkZvcndhcmRpbmdDb21wb25lbnQsIFNWR1Byb3BzIH0gZnJvbSAncmVhY3QnO1xuXG5jb25zdCBBcnJvd0xlZnQ6IFJlZkZvcndhcmRpbmdDb21wb25lbnQ8U1ZHU1ZHRWxlbWVudCwgU1ZHUHJvcHM8U1ZHU1ZHRWxlbWVudD4+ID0gKHByb3BzLCByZWYpID0+IChcbiAgPHN2ZyB3aWR0aD17MjR9IGhlaWdodD17MjR9IHZpZXdCb3g9XCIwIDAgMjQgMjRcIiB7Li4ucHJvcHN9IHJlZj17cmVmfT5cbiAgICA8cGF0aFxuICAgICAgZD1cIk0xOC4yNTMgMTIuNjMySDcuMjYybDMuNjIxIDMuNjE2YS42MjUuNjI1IDAgMTEtLjg4NS44ODRsLTQuNjk1LTQuNjg5YS42MjQuNjI0IDAgMDEwLS44ODRMOS45OTggNi44N2EuNjI2LjYyNiAwIDExLjg4NS44ODRsLTMuNjMyIDMuNjI4aDExLjAwMmEuNjI1LjYyNSAwIDExMCAxLjI1elwiXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAvPlxuICA8L3N2Zz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IGZvcndhcmRSZWYoQXJyb3dMZWZ0KTtcbiJdfQ==